import { IAudioHandles } from "providers/AudioProvider/handleTypes";

export interface ReplaceByIntervalResult {
    created: number;
    removed: number;
    error?: string;
}

/**
 * Распознать промежуток заново и заменить им старые реплики — в таком порядке: сначала новые
 * реплики, потом удаление старых (кроме тех, что сервер вернул как созданные). Не распозналось
 * или речи нет — старые остаются как были.
 *
 * Подтверждение удаления переводчик уже дал в диалоге инструмента, поэтому второй вопрос
 * (window.confirm у deleteSubtitles) не задаётся: отказ на нём после создания оставил бы
 * новые реплики поверх старых.
 */
export const replaceByInterval = async ({
    start,
    end,
    overlapping,
    handles,
}: {
    start: number;
    end: number;
    overlapping: string[];
    handles: Pick<IAudioHandles, "createRusSubIntervalMulti" | "deleteSubtitles">;
}): Promise<ReplaceByIntervalResult> => {
    const result = await handles.createRusSubIntervalMulti({ start, end });
    if (result.error) {
        return { created: 0, removed: 0, error: result.error };
    }
    if (!result.created_count) {
        return { created: 0, removed: 0 };
    }
    const created = new Set(result.created_ids || []);
    const toRemove = overlapping.filter((id) => !created.has(id));
    if (!toRemove.length) {
        return { created: result.created_count, removed: 0 };
    }
    const removed = await handles.deleteSubtitles(toRemove, { confirmed: true });
    if (removed?.error) {
        return { created: result.created_count, removed: 0, error: removed.error };
    }
    return { created: result.created_count, removed: toRemove.length };
};
